import { render, staticRenderFns } from "./Game2-9.vue?vue&type=template&id=493bde34&scoped=true&"
import script from "./Game2-9.vue?vue&type=script&lang=js&"
export * from "./Game2-9.vue?vue&type=script&lang=js&"
import style0 from "./Game2-9.vue?vue&type=style&index=0&id=493bde34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "493bde34",
  null
  
)

export default component.exports